import React, { PureComponent } from 'react';

// components
import StripeContainer from '../../components/stripe';

class PaymentScreen extends PureComponent {
    componentDidMount() {
        this.props.setStep('PAYMENT');
    }

    render() {
        const { history } = this.props;
        return (
            <div className="container-fluid wrapper services">
                <StripeContainer history={history} />
            </div>
        );
    }
}

export default PaymentScreen;
